import {
    Box,
    styled,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TablePaginationProps,
    Typography
} from '@mui/material';
import { FunctionComponent } from 'react';

import { colors } from '../../../../theme';

export const Wrapper = styled(Box)`
    width: 100%;
    
    @media (max-width: 768px) {
        padding: 0 8px;
    }
`;

export const Container = styled(Box)`
    overflow-x: auto;
    width: 90%;
    
    @media (max-width: 768px) {
        margin: 0 -8px;
        width: calc(100% + 16px);
        
        & .MuiTable-root {
            min-width: 800px;
        }
    }
`;

export const StyledTableHead = styled(TableHead)`
    th {
        background-color: ${colors.darkBlue};
        border-bottom: 0.5px solid ${colors.white30};
        padding: 24px;
        white-space: nowrap;
        
        @media (max-width: 1024px) {
            padding: 16px 12px;
        }
        
        @media (max-width: 768px) {
            padding: 12px 8px;
            font-size: 10px;
        }
        
        svg {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 100%;
            color: ${colors.white90};
            
            @media (max-width: 768px) {
                width: 14px;
                height: 14px;
            }
        }
        
        label {
            font: 500 12px/15px 'Inter', sans-serif !important;
            color: ${colors.white90};
            cursor: pointer;
            position: relative;
            
            @media (max-width: 768px) {
                font: 500 10px/13px 'Inter', sans-serif !important;
            }
        }
    }
`;

export const StyledTableBody = styled(TableBody)`
    td {
        background-color: ${colors.darkBlue};
        font: 12px/18px 'Inter', sans-serif;
        color: ${colors.white70};
        border-bottom: 0.5px solid ${colors.tuna};
        padding: 24px;
        white-space: nowrap;
        
        @media (max-width: 1024px) {
            padding: 16px 12px;
        }
        
        @media (max-width: 768px) {
            padding: 12px 8px;
            font: 11px/16px 'Inter', sans-serif;
        }
    }
`;

export const StyledTableFooter = styled(TableFooter)`
    background-color: ${colors.darkBlue};
    & td, & .MuiTablePagination-root {
        background-color: ${colors.darkBlue};
    }
    .MuiSelect-select {
        position: relative;
        top: 3px;
        background-color: ${colors.darkBlue} !important;
    }
    & .MuiInputBase-root {
        background-color: ${colors.darkBlue};
    }
    & select {
        background-color: ${colors.darkBlue} !important;
        color: ${colors.white50};
    }
    & svg.MuiSelect-icon {
        fill: ${colors.white50};
    }
    & .MuiTablePagination-root {
        padding: 8px 0px !important;
        border-bottom: none;
        @media (max-width: 768px) {
            & .MuiTablePagination-selectLabel,
            & .MuiTablePagination-displayedRows {
                font: 10px/10px 'Inter', sans-serif !important;
            }
        }
        & div,
        p {
            font: 12px/12px 'Inter', sans-serif !important;
            color: ${colors.white50};
            @media (max-width: 768px) {
                font: 10px/10px 'Inter', sans-serif !important;
            }
        }
    }
    & .MuiTablePagination-actions {
        @media (max-width: 768px) {
            margin-left: 8px;
            
            button {
                padding: 4px;
            }
        }
    }
`;

export const ProjectCell = styled(TableCell)`
    width: 12%;
`;

export const TimeCreatedCell = styled(ProjectCell)``;

export const TaskNameCell = styled(TableCell)`
    width: 30%;
`;

export const NetWorkingTimeCell = styled(ProjectCell)``;

export const DescriptionAndIssuesCell = styled(TableCell)`
    width: 22%;
    text-align: left;
    min-width: 200px;
    white-space: normal;
    word-break: break-word;
    
    @media (max-width: 768px) {
        min-width: 150px;
    }
`;

export const BlameIssuesTooltipContent = styled(Box)`
    cursor: pointer;
    display: flex;
    svg {
        width: 20px;
        height: 20px;
    }
`;

export const IssuesStatusContainer = styled(Box)`
    display: flex;
    svg {
        width: 20px;
        height: 20px;
    }
`;

export const DescriptionWrapper = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Header = styled(Box)`
    display: flex;
    margin-top: 50px;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    padding: 0 120px;
    
    @media (max-width: 1024px) {
        padding: 0 40px;
    }
    
    @media (max-width: 768px) {
        padding: 0 8px;
        flex-direction: column;
        margin-top: 24px;
        gap: 16px;
    }
`;

export const Titles = styled(Box)`
    margin-left: 20px;
    flex: 1;
    
    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;
    }
`;

export const Title = styled(Typography)`
    font: 600 16px/19px 'Inter', sans-serif;
    color: ${colors.white90};
    
    @media (max-width: 768px) {
        font: 600 14px/17px 'Inter', sans-serif;
    }
`;

export const Subtitle = styled(Typography)`
    font: 12px/12px 'Inter', sans-serif;
    color: ${colors.white50};
    margin-top: 10px;
    
    @media (max-width: 768px) {
        font: 11px/11px 'Inter', sans-serif;
        margin-top: 8px;
    }
`;

export const StyledTablePagination: FunctionComponent<TablePaginationProps> = (props) => (
    <TablePagination
        {...props}
        SelectProps={{
            ...props.SelectProps,
            inputProps: {
                style: {
                    backgroundColor: colors.darkBlue,
                    color: colors.white50
                }
            },
            style: { backgroundColor: colors.darkBlue },
            MenuProps: {
                PaperProps: {
                    style: {
                        backgroundColor: colors.darkBlue,
                        color: colors.white50
                    }
                }
            }
        }}
    />
);
